export type LoginStep = 'email' | 'name' | 'otp' | 'password';

export interface MultiMethodLoginFormData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  rememberMe: boolean;
  /** GDPR consent: Terms of Service (required for registration) */
  termsOfService: boolean;
  /** GDPR consent: Privacy Policy (required for registration) */
  privacyPolicy: boolean;
  /** Optional marketing email consent */
  marketingEmail: boolean;
}

export interface LoginFlowState {
  step: LoginStep;
  email: string;
  isNewUser: boolean;
  timestamp: number;
}

export const stepVariants = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -16 }
} as const;
